import { render } from "./ApolicesForm.vue?vue&type=template&id=2af8b6b8"
import script from "./ApolicesForm.vue?vue&type=script&lang=js"
export * from "./ApolicesForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__